import { slotAnzahl, spalten, type Form } from "@gui-creator/gemeinsam";

export type Richtung = "links" | "rechts" | "hoch" | "runter";

export const PFEILE: Record<string, Richtung> = { ArrowLeft: "links", ArrowRight: "rechts", ArrowUp: "hoch", ArrowDown: "runter" };

export function pfeil(i: number, richtung: Richtung, form: Form): number {
  const s = spalten(form);
  const n = slotAnzahl(form);
  const spalte = i % s;
  if (richtung === "links") return spalte > 0 ? i - 1 : i;
  if (richtung === "rechts") return spalte < s - 1 && i + 1 < n ? i + 1 : i;
  if (richtung === "hoch") return i - s >= 0 ? i - s : i;
  return i + s < n ? i + s : i;
}
